
import { Product } from '../../types';
import { KEYS, get, set, generateId } from '../core';

// Local storage functions
export const getProducts = (): Product[] => get<Product>(KEYS.PRODUCTS);
export const setProducts = (products: Product[]): void => set(KEYS.PRODUCTS, products);

// Add basic CRUD functions
export const addProduct = (product: Product): Product => {
  const products = getProducts();
  products.push(product);
  setProducts(products);
  return product;
};

export const updateProduct = (updatedProduct: Product): Product => {
  const products = getProducts();
  const index = products.findIndex(p => p.id === updatedProduct.id);
  
  if (index >= 0) {
    products[index] = updatedProduct;
    setProducts(products);
    return updatedProduct;
  }
  
  throw new Error(`Product with ID ${updatedProduct.id} not found`);
};

export const deleteProduct = (productId: string): void => {
  const products = getProducts();
  const filteredProducts = products.filter(p => p.id !== productId);
  
  if (filteredProducts.length < products.length) {
    setProducts(filteredProducts);
  } else {
    throw new Error(`Product with ID ${productId} not found`);
  }
};
